__turbopack_context__.v({
  "icons": "SoftwareTechStack-module__RjK2SW__icons",
  "riseIn": "SoftwareTechStack-module__RjK2SW__riseIn",
  "root": "SoftwareTechStack-module__RjK2SW__root",
});
